(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/legal-info/assets/javascripts/react/components/login-check/check-terms/accept-terms.js') >= 0) return;  svs.modules.push('/modules/legal-info/assets/javascripts/react/components/login-check/check-terms/accept-terms.js');

'use strict';

const {
  ReactIcon: Icon,
  ReactButton: Button
} = svs.ui;
const {
  returnUrl
} = svs.utils.url.queryString;
const {
  isPnp
} = svs.legal_info.data;
const {
  personalInformationDoc,
  getCMSUrl,
  isPoker
} = svs.legal_info.data.loginCheckOptions.model;
const AcceptTerms = () => {
  const isNativeApp = Boolean(svs.core.config.data.svsconfig.isNativeApp);
  const docs = "/dokument/".concat(personalInformationDoc);
  const docsNative = "".concat(getCMSUrl, " ").concat(personalInformationDoc);
  const handleAcceptTerms = async () => {
    svs.core.jupiter.call({
      method: 'POST',
      path: '/player/1/terms',
      data: {}
    }, () => svs.utils.url.navigate(returnUrl), err => {
      svs.accountservices.check_terms.logger.error('Unable to POST new accepted terms to /player/1/terms', err);
      svs.utils.url.navigate(returnUrl);
    });
  };
  return React.createElement("section", {
    className: "f-content"
  }, React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement("div", {
    "aria-hidden": "true",
    className: "margin-top-1 margin-bottom-2 align-center"
  }, React.createElement(Icon, {
    color: isPnp ? 'fc-momang' : 'fc-sport-75',
    icon: "gdpr-terms-changes",
    size: "1000"
  })), React.createElement("h1", {
    className: "align-center f-prominent"
  }, "V\xE4lkommen till Svenska Spel Sport & Casino!"), React.createElement("div", {
    className: "padding-xs-h-1"
  }, React.createElement("p", null, React.createElement("span", {
    className: "margin-top-1"
  }, "F\xF6r att logga in och spela beh\xF6ver du godk\xE4nna f\xF6ljande:", React.createElement("br", null), React.createElement("br", null), "F\xF6r spel hos Svenska Spel Sport & Casino AB vid var tid g\xE4llande", ' '), React.createElement("a", {
    className: isPnp ? 'fc-momang' : 'fc-sport-75',
    href: svs.core.urlMapping.get('termsIntegrityHome'),
    rel: "noreferrer",
    target: "_blank"
  }, "Kundvillkor"), ".", React.createElement("span", null, ' ', "D\xE4r finns bland annat information om hur dina pengar skyddas.")), React.createElement("p", null, React.createElement("span", null, "Dina personuppgifter behandlas p\xE5 det s\xE4tt som framg\xE5r av", ' '), React.createElement("a", {
    className: isPnp ? 'fc-momang' : 'fc-sport-75',
    href: isNativeApp ? docsNative : docs,
    rel: "noreferrer",
    target: "_blank"
  }, "Sport & Casino Information om behandling av personuppgifter"), "."), React.createElement("div", {
    className: "grid-row gutter-xs-1 margin-top-2"
  }, isPoker ? React.createElement("div", {
    className: "col-xs-6 col-xs-offset-3"
  }, React.createElement(Button, {
    block: true,
    onClick: handleAcceptTerms
  }, "Godk\xE4nn")) : React.createElement(React.Fragment, null, React.createElement("div", {
    className: "col-xs-6"
  }, React.createElement(Button, {
    block: true,
    focus: true,
    href: "/logga-ut",
    role: "link",
    transparent: true
  }, "Logga ut")), React.createElement("div", {
    className: "col-xs-6"
  }, React.createElement(Button, {
    block: true,
    focus: true,
    inverted: isPnp,
    onClick: handleAcceptTerms
  }, "Godk\xE4nn")))), React.createElement("div", {
    className: "margin-top-2"
  }, "Har du fr\xE5gor? Kontakta", ' ', isPoker ? React.createElement("span", null, "Kundservice Svenska Spel Sport & Casino: 0770 - 11 11 11") : React.createElement("a", {
    className: isPnp ? 'fc-momang' : 'fc-sport-75',
    href: svs.core.urlMapping.get('customerServiceContact')
  }, "Kundservice Svenska Spel Sport & Casino")))));
};
svs.legal_info.components.login_check.check_terms.AcceptTerms = AcceptTerms;

 })(window);